export default __webpack_public_path__ + "static/media/journal1image1.9f78c5a6.png";